import angular from 'angular';

/* @ngInject */
export default function ($scope, LayoutService, TrainingModules, toastr, $state, $stateParams, TrainingModuleVersions) {
	$scope.courseId  = $stateParams.courseId;
	$scope.moduleId  = $stateParams.moduleId;
	$scope.versionId = $stateParams.versionId;
	$scope.loading   = true;

	$scope.version = {
		version:     '',
		attachments: [],
		items:       [],
	};

	$scope.refresh = () => {
		$scope.loading = true;

		TrainingModuleVersions.one($scope.versionId)
		                      .get({
			                      include: 'module.course,attachments.document,items',
		                      })
		                      .then((version) => {
			                      $scope.existingVersion = version;
			                      $scope.loading         = false;

			                      $scope.version = {
				                      version:     $scope.existingVersion.version,
				                      attachments: [
					                      ...$scope.existingVersion.attachments.map((attachment) => {
						                               return {
							                               ...attachment,
						                               };
					                               })
					                               .sort((a, b) => {
						                               return a.sort - b.sort;
					                               }),
				                      ],
				                      items:       [
					                      ...$scope.existingVersion.items.map((item) => {
						                               return {
							                               ...item,
							                               answers: [
								                               ...item.answers.map((answer) => {
									                               return {
										                               value: answer,
									                               };
								                               }),
							                               ],
						                               };
					                               })
					                               .sort((a, b) => {
						                               return a.sort - b.sort;
					                               }),
				                      ],
			                      };

			                      $scope.updateLayout($scope.existingVersion.module.course.name, $scope.existingVersion.module.title, $scope.existingVersion.version);
		                      })
		                      .catch((error) => {
			                      toastr.clear();
			                      toastr.error('There was an error while loading this version, please try again.', 'Error');

			                      $state.go('staff.training.management.modules.view', {
				                      courseId: $scope.courseId,
				                      moduleId: $scope.moduleId,
			                      });

			                      $scope.loading = false;
		                      });
	};

	$scope.addAttachment = (type) => {
		let attachment = {
			sort:     $scope.version.attachments.length,
			title:    '',
			document: '',
			type,
		};

		$scope.version.attachments.push(attachment);
	};

	$scope.removeAttachment = (index) => {
		$scope.version.attachments.splice(index, 1);
	};

	$scope.addItem = (type) => {
		let item = {
			sort:    $scope.version.items.length,
			label:   '',
			type,
			options: [],
			answers: [],
		};

		$scope.version.items.push(item);
	};

	$scope.addItemOption = (item) => {
		item.options.push({
			label: '',
			value: '',
		});
	};

	$scope.removeItemOption = (item, index) => {
		item.options.splice(index, 1);
	};

	$scope.addItemAnswer = (item) => {
		item.answers.push({
			value: '',
		});
	};

	$scope.removeItemAnswer = (item, index) => {
		item.answers.splice(index, 1);
	};

	$scope.removeItem = (index) => {
		$scope.version.items.splice(index, 1);
	};

	$scope.save = () => {
		if (!$scope.loading) {
			const errors = $scope.validate();

			if (errors.length === 0) {
				const version = {
					version:     $scope.version.version,
					attachments: [
						...$scope.version.attachments.sort((a, b) => {
							         return a.sort - b.sort;
						         })
						         .map((attachment) => {
							         return {
								         title:    attachment.title,
								         document: attachment.document,
								         type:     attachment.type,
							         };
						         }),
					],
					items:       [
						...$scope.version.items.sort((a, b) => {
							         return a.sort - b.sort;
						         })
						         .map((item) => {
							         return {
								         label:   item.label,
								         type:    item.type,
								         options: [
									         ...item.options,
								         ],
								         answers: [
									         ...item.answers.map((answer) => {
										         return answer.value;
									         }),
								         ],
							         };
						         }),
					],
				};

				TrainingModules.one($scope.moduleId)
				               .post('versions', version)
				               .then((returnedVersion) => {
					               toastr.clear();
					               toastr.success('The version was created successfully.', 'Version Created');

					               $state.go('staff.training.management.modules.view', {
						               courseId: $scope.courseId,
						               moduleId: $scope.moduleId,
					               });
				               })
				               .catch((error) => {
					               toastr.clear();
					               toastr.error('There was an error while creating the version, please try again.', 'Error');
				               });
			} else {
				let uniqueErrors = [
					...new Set(errors),
				];

				uniqueErrors = uniqueErrors.map((error) => {
					return `<li>${error}</li>`;
				});

				uniqueErrors = uniqueErrors.join('');

				toastr.clear();
				toastr.warning(`<ul>${uniqueErrors}</ul>`, 'Warning', {
					allowHtml: true,
				});
			}
		} else {
			toastr.clear();
			toastr.warning('You must wait for the module to load.', 'Warning');
		}
	};

	$scope.validate = () => {
		let errors = [];

		if ($scope.version.version.length === 0) {
			errors.push(`You must set the version name.`);
		}

		if ($scope.version.version === $scope.existingVersion.version) {
			errors.push(`The version name must be different from the previous version.`);
		}

		let attachmentSorts = [];

		angular.forEach($scope.version.attachments, (attachment) => {
			switch (attachment.type) {
				case 'file': {
					if (attachment.title.length === 0) {
						errors.push(`You must set the title for all attachments.`);

						break;
					}

					if (attachmentSorts.indexOf(attachment.sort) !== -1) {
						errors.push(`You must set a unique sort value for attachment "${attachment.title}".`);

						break;
					} else {
						attachmentSorts.push(attachment.sort);
					}

					if (attachment.document.length === 0) {
						errors.push(`You must set the source file for attachment "${attachment.title}".`);
					}

					break;
				}

				case 'video': {
					if (attachment.title.length === 0) {
						errors.push(`You must set the title for all attachments.`);

						break;
					}

					if (attachmentSorts.indexOf(attachment.sort) !== -1) {
						errors.push(`You must set a unique sort value for attachment "${attachment.title}".`);

						break;
					} else {
						attachmentSorts.push(attachment.sort);
					}

					if (attachment.document.length === 0) {
						errors.push(`You must set the source file for attachment "${attachment.title}".`);
					}

					break;
				}
			}
		});

		if ($scope.version.items.length === 0) {
			errors.push(`You must add at least 1 item.`);
		}

		let itemSorts = [];

		angular.forEach($scope.version.items, (item) => {
			switch (item.type) {
				case 'radio':
				case 'checkbox': {
					if (item.label.length === 0) {
						errors.push(`You must set the label for all items.`);

						break;
					}

					if (itemSorts.indexOf(item.sort) !== -1) {
						errors.push(`You must set a unique sort value for item "${item.label}".`);

						break;
					} else {
						itemSorts.push(item.sort);
					}

					if (item.options.length === 0) {
						errors.push(`You must add at least 1 option for item "${item.label}".`);
					}

					if (item.options.filter((option) => {
						return option.label === '' || option.value === '';
					}).length > 0) {
						errors.push(`You must not have any empty options for item "${item.label}".`);
					}

					if (item.answers.length === 0) {
						errors.push(`You must add at least 1 answer for item "${item.label}".`);
					}

					if (item.answers.filter((answer) => {
						return answer.value === '';
					}).length > 0) {
						errors.push(`You must not have any empty answers for item "${item.label}".`);
					}

					const availableAnswers = item.options.filter((option) => {
						                             return option.value !== '';
					                             })
					                             .map((option) => {
						                             return option.value;
					                             });

					item.answers.forEach((answer) => {
						if (availableAnswers.indexOf(answer.value) === -1) {
							errors.push(`The answer "${answer.value}" is not a valid Key for item "${item.label}".`);
						}
					});

					break;
				}

				case 'string':
				case 'textarea':
				case 'comment': {
					if (item.label.length === 0) {
						errors.push(`You must set the label for all items.`);

						break;
					}

					if (itemSorts.indexOf(item.sort) !== -1) {
						errors.push(`You must set a unique sort value for item "${item.label}".`);

						break;
					} else {
						itemSorts.push(item.sort);
					}

					break;
				}

				case 'static-text': {
					if (item.label.length === 0) {
						errors.push(`You must set the label for all items.`);

						break;
					}

					break;
				}
			}
		});

		return errors;
	};

	$scope.updateLayout = (courseName = 'Loading...', moduleName = 'Loading...', versionName = 'Loading...') => {
		LayoutService.reset();

		let newVersionText = 'New Version';

		if (versionName !== 'Loading...') {
			newVersionText += ` From ${versionName}`;
		}

		LayoutService.setTitle([
			newVersionText,
			moduleName,
			courseName,
			'Management',
			'Training',
		]);

		LayoutService.getPageHeader()
		             .setBreadcrumbs([
			             {
				             route:       'staff.dashboard',
				             displayName: 'Dashboard',
			             },
			             {
				             route:       'staff.training.root',
				             displayName: 'Training',
			             },
			             {
				             route:       'staff.training.management.root',
				             displayName: 'Management',
			             },
			             {
				             route:       `staff.training.management.view({ courseId: "${$scope.courseId}" })`,
				             displayName: courseName,
			             },
			             {
				             route:       `staff.training.management.modules.view({ courseId: "${$scope.courseId}", moduleId: "${$scope.moduleId}" })`,
				             displayName: moduleName,
			             },
			             {
				             route:       `staff.training.management.modules.versions.edit({ courseId: "${$scope.courseId}", moduleId: "${$scope.moduleId}", versionId: "${$scope.versionId}" })`,
				             displayName: newVersionText,
			             },
		             ]);

		LayoutService.getPageHeader()
		             .setActionButton('<button type="button" class="btn btn-primary pull-right"><i class="fa fa-check"></i> Save</button>');

		LayoutService.getPageHeader()
		             .onClicked($scope.save);
	};

	$scope.updateLayout();
	$scope.refresh();
};


// WEBPACK FOOTER //
// ./src/js/endpoints/staff/training/management/modules/versions/edit/controller.js